module.exports = __webpack_public_path__ + "img/efo-logo.8d2a924b.gif";